import React, { FC } from 'react';
import style from 'app/modules/mediaLibrary/components/mediaLibraryModal/albumSelect/AlbumItem.module.scss';
import { MediaLibraryAlbum } from 'types/MediaLibrary';
import { TYPE_UNSPECIFIED } from '@kontentino/kontentino-constants/Pages';
import { SocialMediaIcon, SocialMediaIconProps } from '@kontentino/ui';
import PageTypeUtils from 'app/utils/pageType';
import { getYtLogoGuidelineSize } from 'app/utils/getytlogoguidelinesize';
import { useTranslation } from 'react-i18next';

type Props = {
  album: MediaLibraryAlbum;
  onClick?: AnyFunction;
};

const AlbumItem: FC<Props> = ({ album, onClick }) => {
  const { t } = useTranslation();
  return (
    <div className={style.album} onClick={onClick}>
      <SocialMediaIcon
        type={
          PageTypeUtils.getName(
            album.page?.type ?? TYPE_UNSPECIFIED,
          ) as SocialMediaIconProps['type']
        }
        size={getYtLogoGuidelineSize(18, album.page?.type ?? TYPE_UNSPECIFIED)}
      />
      <div className={style.desc}>
        <span className={style.name}>
          {album.page?.name ? `${album.page.name} - ` : ''}
        </span>
        <span>{album.name}</span>
        <span className={style.counts}>
          {`(${t('imageWithCount', { count: album.images_count })}, ${t(
            'videoWithCount',
            { count: album.videos_count },
          )})`}
        </span>
      </div>
    </div>
  );
};

export default AlbumItem;
